import React, { forwardRef, Ref } from 'react';
import { IconTypes } from '@eika/icon';
import { StandardButtonTypes } from '../ButtonTypes';
import Button, { BasicButtonProps } from '../Button';

export interface StandardButtonProps extends BasicButtonProps {
    buttonType?: StandardButtonTypes;
    icon?: IconTypes;
}

const StandardButton = forwardRef(
    ({ children, buttonType = 'positive', ...rest }: StandardButtonProps, ref: Ref<HTMLButtonElement>): JSX.Element => (
        <Button buttonType={buttonType} {...rest} ref={ref}>
            {children}
        </Button>
    )
);

export default StandardButton;
